import {makeBreadCrumbJson, SEO} from '../../components/shared/seo';
import Section from '../../atoms/Section/Section';
import {Grid} from 'react-styled-flexboxgrid';
import React from 'react';
import {Container} from '../../atoms/Container';
import {P} from '../../atoms/TextComponents';
import styled from 'styled-components';
import FlexWrapper from '../../components/shared/FlexWrapper';
import {BooleanParam, StringParam, useQueryParam} from 'use-query-params';
import MiurosLogoSvg from '../../../assets/logos/MiurosLogoDark.svg';

/* region ATOMS */
const ConnectionStatusBanner = styled('div')`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 50px;
  background-color: ${props => props.success ? '#68D391' : '#F56565'};
  color: #ffffff;
  box-shadow: 0 4px 16px rgba(74, 85, 104, 0.1);

  animation-duration: 300ms;
  animation-fill-mode: both;
  animation-name: slideInDown;

  @keyframes slideInDown {
    from {
      transform: translate3d(0, -100%, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

`;

const CloseBannerButtonStyled = styled('button')`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  border: none;
  padding: 0;
  width: 36px;
  height: 100%;
  background: none;
  box-sizing: content-box;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
  }
`;

const CloseBannerButton = ({callback}) => {
  return (
      <CloseBannerButtonStyled onClick={() => callback()}>
        <svg className="close-icon" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
              d="M7.75706 5.63599L5.63574 7.75731L9.87838 11.9999L5.63574 16.2426L7.75706 18.3639L11.9997 14.1213L16.2423 18.3639L18.3637 16.2426L14.121 11.9999L18.3637 7.75731L16.2423 5.63599L11.9997 9.87863L7.75706 5.63599Z"
              fill="white"/>
        </svg>
      </CloseBannerButtonStyled>
  );
};

const PlusSvg = () => (
    <svg className="plus" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L14 6V14L6.00005 14L6.00005 18L14 18V26L18 26V18H26V14H18V6Z"/>
    </svg>
);

const FrontLogoSvg = () => (
    <svg className="front" viewBox="0 0 520 740" xmlns="http://www.w3.org/2000/svg">
      <path
          d="M139.203 644.415V624.302H111.41V738.198H130.155C135.15 738.198 139.203 734.145 139.203 729.151V684.412C139.203 662.717 146.205 647.572 163.838 647.572H181.689V624.293H168.353C153.67 624.302 144.857 629.948 139.203 644.415Z"
          fill="black"/>
      <path
          d="M246.092 622.494C211.288 622.494 186.435 647.356 186.435 681.247C186.435 715.138 211.297 740 246.092 740C280.671 740 305.524 715.138 305.524 681.247C305.524 647.356 280.671 622.494 246.092 622.494ZM246.092 716.052C227.111 716.052 214.454 701.812 214.454 681.247C214.454 660.683 227.111 646.442 246.092 646.442C264.847 646.442 277.505 660.683 277.505 681.247C277.505 701.812 264.847 716.052 246.092 716.052Z"
          fill="black"/>
      <path
          d="M385.755 622.494C369.488 622.494 356.605 629.497 350.272 641.928V624.304H322.478V738.2H341.225C346.219 738.2 350.272 734.146 350.272 729.152V676.054C350.272 659.335 361.119 647.13 376.708 647.13C390.948 647.13 400.439 657.978 400.439 673.575V738.209H419.185C424.179 738.209 428.232 734.155 428.232 729.161V667.694C428.241 641.023 411.513 622.494 385.755 622.494Z"
          fill="black"/>
      <path
          d="M519.992 638.537V624.306H488.353V589.953H460.56V616.842C460.56 622.261 457.846 624.297 453.331 624.297H438.186V647.575H460.56V698.421C460.56 723.735 476.836 738.193 501.689 738.193H519.992V713.105H504.847C494.451 713.105 488.345 707.233 488.345 695.707V647.575H510.936C515.939 647.585 519.992 643.531 519.992 638.537Z"
          fill="black"/>
      <path
          d="M0 608.707V738.2H20.782C25.776 738.2 29.829 734.147 29.829 729.153V671.757H90.391V645.991H29.829V613.674C29.829 609.304 33.366 605.767 37.736 605.767H96.263C101.257 605.767 105.31 601.713 105.31 596.719V580H28.698C12.856 580.009 0 592.856 0 608.707Z"
          fill="black"/>
      <path
          d="M420 201C420 141.353 371.647 93 312 93C252.353 93 204 141.353 204 201C204 260.647 252.353 309 312 309C371.647 309 420 260.647 420 201Z"
          fill="url(#paint0_linear_7559:39117)"/>
      <path fillRule="evenodd" clipRule="evenodd"
            d="M194.2 0C148.25 0 111 37.25 111 83.2V500H229.4C252.375 500 271 481.375 271 458.4V300.946C231.685 284.801 204 246.134 204 201C204 141.353 252.353 93 312 93C357.134 93 395.801 120.685 411.946 160H419.4C442.375 160 461 141.375 461 118.4V0H194.2Z"
            fill="black"/>
      <path opacity="0.9" fillRule="evenodd" clipRule="evenodd"
            d="M411.946 160H311C288.909 160 271 177.909 271 200V300.946C231.685 284.801 204 246.133 204 201C204 141.353 252.353 93 312 93C357.133 93 395.801 120.685 411.946 160Z"
            fill="url(#paint1_linear_7559:39117)"/>
      <defs>
        <linearGradient id="paint0_linear_7559:39117" x1="380.5" y1="293" x2="240.871" y2="102.094"
                        gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.8"/>
          <stop offset="0.838542" stopOpacity="0.16"/>
        </linearGradient>
        <linearGradient id="paint1_linear_7559:39117" x1="234" y1="123" x2="402.612" y2="289.386"
                        gradientUnits="userSpaceOnUse">
          <stop/>
          <stop offset="1" stopOpacity="0.16"/>
        </linearGradient>
      </defs>
    </svg>
);


const FrontOauthBtnStyled = styled('a')`
  display: block;
  margin: 16px auto;
  border-radius: 48px;
  padding: 15px 0;
  background: #001b38;
  color: #fff;
  width: 270px;
  font-weight: 700;
  font-size: 16px;
  text-align: center;
  line-height: 113%;
  transition: all .15s ease 0s;

  &:hover {
    background: #cc0049;
  }
`;

const FrontOAuthBtn = ({clientId, redirectURI}) => {
  return (
      <FrontOauthBtnStyled
          href={`https://app.frontapp.com/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectURI}`}>
        Connect with Front
      </FrontOauthBtnStyled>
  );
};

const CardWrapper = styled('div')`
  border-radius: 4px;
  padding: 24px;
  max-width: 600px;
  box-shadow: 0 4px 16px rgba(74, 85, 104, 0.1);
  background-color: white;
`;

const LogoContainer = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 24px;

  img, svg {
    height: 52px;
  }

  .front, .miuros {
    fill: #000000;
  }

  .plus {
    margin-left: 4px;
    margin-right: 4px;
    fill: #4A5568;
  }
`;

const FrontContainer = styled(Container)`
  padding: 80px 0;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSIzOTIiIHZpZXdCb3g9IjAgMCAxNDQwIDM5MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC41Ij4KPHBhdGggZD0iTS0xNDEuOTQxIDE5NkMtMTQxLjk0MSA4Ny43NTIxIC01NC41ODAzIDAgNTMuMTg0MiAwQzE2MC45NDkgMCAyNDguMzA5IDg3Ljc1MjEgMjQ4LjMwOSAxOTZDMjQ4LjMwOSAzMDQuMjQ3IDE2MC45NDkgMzkxLjk5OSA1My4xODQyIDM5MS45OTlDLTU0LjU4MDMgMzkxLjk5OSAtMTQxLjk0MSAzMDQuMjQ3IC0xNDEuOTQxIDE5NloiIGZpbGw9IiNFREYyRjciLz4KPHBhdGggZD0iTTY3OC4xMDggMTYwLjc4NEM3MDkuNTE0IDIxNS40MjMgNjkwLjg3NyAyODUuMjkgNjM2LjQ4MSAzMTYuODM3TDUzMy4yOTkgMzc2LjY3NkM0NzguOTAzIDQwOC4yMjIgNDA5LjM0OCAzODkuNTAxIDM3Ny45NDIgMzM0Ljg2MkwzMTguMzcgMjMxLjIxN0MyODYuOTY1IDE3Ni41NzcgMzA1LjYwMiAxMDYuNzEgMzU5Ljk5OCA3NS4xNjRMNDYzLjE4IDE1LjMyNDdDNTE3LjU3NiAtMTYuMjIxNSA1ODcuMTMxIDIuNDk5NDMgNjE4LjUzNiA1Ny4xMzlMNjc4LjEwOCAxNjAuNzg0WiIgZmlsbD0iI0VERjJGNyIvPgo8cGF0aCBkPSJNODcwLjE1NiAzOTAuMzcxQzg0NC45NTMgMzk3LjE1NSA4MTkuMDQ3IDM4Mi4xMzEgODEyLjI5NCAzNTYuODE1TDc0OS43OTcgMTIyLjUyOEM3NDMuMDQ0IDk3LjIxMTYgNzU4IDcxLjE4OTkgNzgzLjIwNCA2NC40MDY0TDEwMTYuNDUgMS42MjkzN0MxMDQxLjY1IC01LjE1NDA0IDEwNjcuNTUgOS44Njk2IDEwNzQuMzEgMzUuMTg1N0wxMTM2LjggMjY5LjQ3M0MxMTQzLjU2IDI5NC43ODkgMTEyOC42IDMyMC44MTEgMTEwMy40IDMyNy41OTRMODcwLjE1NiAzOTAuMzcxWiIgZmlsbD0iI0VERjJGNyIvPgo8cGF0aCBkPSJNMTE5My4yMyAyNC41QzExOTMuMjMgMTAuOTY5IDEyMDQuMTUgMCAxMjE3LjYzIDBMMTU1OS4wOSAwQzE1NzIuNTYgMCAxNTgzLjQ4IDEwLjk2OSAxNTgzLjQ4IDI0LjVWMzY3LjQ5OUMxNTgzLjQ4IDM4MS4wMyAxNTcyLjU2IDM5MS45OTkgMTU1OS4wOSAzOTEuOTk5TDEyMTcuNjMgMzkxLjk5OUMxMjA0LjE1IDM5MS45OTkgMTE5My4yMyAzODEuMDMgMTE5My4yMyAzNjcuNDk5VjI0LjVaIiBmaWxsPSIjRURGMkY3Ii8+CjwvZz4KPC9zdmc+Cg==);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

const FrontSection = styled(Section)`
  padding: 56px 0;
`;

const CustomerSupportWrapper = styled('span')`
  a {
    cursor: pointer;

    &:after {
      content: attr(data-a) "@" attr(data-b) "." attr(data-c);
    }
  }
`;

/* endregion */

const Front = ({data, pageContext}) => {
  // query param handling
  const [integrationSuccessful, setIntegrationSuccessful] = useQueryParam('integration-successful', BooleanParam);
  const [errorMessage, setErrorMessage] = useQueryParam('error-message', StringParam);

  const resetQueryParams = () => {
    setIntegrationSuccessful(undefined);
    setErrorMessage(undefined);
  };

  if (errorMessage && errorMessage.length) {
    console.error(errorMessage);
  }

  const metaOptions = [
    {
      property: `og:title`,
      content: 'Connect Miuros and Front'
    },
    {
      property: `og:description`,
      content: 'Connect Miuros and Front'
    }];

  const defaultBreadcrumbs = [
    {
      name: 'Miuros',
      item: 'https://miuros.com/'
    },
    {
      name: 'Connect Front',
      item: 'https://miuros.com/connect/front/'
    }
  ];

  const breadcrumbs = makeBreadCrumbJson(defaultBreadcrumbs);
  const buildEnv = process.env.GATSBY_BUILD_ENV;
  const frontClientId = process.env.GATSBY_FRONT_CLIENT_ID;
  let redirectUri;
  switch (buildEnv) {
    case 'prd':
      redirectUri = 'https://miuros.com:8000/oauth2redirect/front';
      break;
    case 'pre':
      redirectUri = 'https://pre.miuros.com:8000/oauth2redirect/front';
      break;
    case 'dev':
      redirectUri = 'https://dev.miuros.cloud:8000/oauth2redirect/front';
      break;
  }

  return (
      <>
        <SEO title={'Connect Front'} description={'Connect Miuros and Front'} meta={metaOptions}
             breadCrumbJson={breadcrumbs}/>

        <FrontContainer>
          {
            integrationSuccessful !== undefined &&
            <ConnectionStatusBanner success={integrationSuccessful}>
              <p>{integrationSuccessful ?
                  'Your Front account has been successfully added to Miuros' :
                  'We\'re sorry, there was an error while trying to add Front account. Please contact us if the issue persists.'}</p>
              <CloseBannerButton callback={resetQueryParams}/>
            </ConnectionStatusBanner>
          }
          <FrontSection>
            <Grid>
              <FlexWrapper column justify="center" align="center">

                <CardWrapper>

                  <LogoContainer>
                    <img src={MiurosLogoSvg} alt="Miuros"/>
                    <PlusSvg/>
                    <FrontLogoSvg/>
                  </LogoContainer>

                  <P>Hello there,<br/>
                    If you are already a Miuros customer, click the button below to connect Miuros to your Front
                    instance. After the connection is set up, our CSM team will get in touch to begin your onboarding
                    process. If you have any questions in the meantime, please
                    contact <CustomerSupportWrapper>
                      <a data-a="support"
                         data-b="miuros"
                         data-c="com" onClick={(e) => {
                        e.preventDefault();
                        window.open('mailto:support@miuros.com', '_self');
                      }}/>
                    </CustomerSupportWrapper>.</P>
                  <FrontOAuthBtn
                      clientId={frontClientId}
                      redirectURI={redirectUri}
                      useAlt={true}>
                  </FrontOAuthBtn>
                  <P>If you are not a customer yet, <a href={'https://dixa.com/demo'}>schedule a call with
                    us</a> to see
                    Miuros Review & Insights in action and learn more about how we can help.</P>
                </CardWrapper>
              </FlexWrapper>
            </Grid>
          </FrontSection>
        </FrontContainer>
      </>
  );
};

export default Front;
